import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { IndicatorService } from '@app/shared';

@Component({
  selector: 'navaar-webview-page',
  templateUrl: './webview-page.component.html',
  styleUrls: ['./webview-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WebviewPageComponent implements OnInit {
  public link: string;
  constructor(
    private readonly indicator: IndicatorService,
    private readonly sanitizer: DomSanitizer,
    private readonly activeRoute: ActivatedRoute) { }

  ngOnInit() {
    this.link = this.activeRoute.snapshot.queryParamMap.get('link');
    this.indicator.hide();
  }
  public cleanURL(link: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(link);
  }
}
